import axios from 'axios';
import Qs from 'qs';

const axiosPlugin = {};

// Program all Axios defaults here
axios.defaults.baseURL = process.env.VUE_APP_API_ROOT || '';
axios.defaults.paramsSerializer = params => Qs.stringify(params, { arrayFormat: 'indices' });

let localAxios = axios.create({
  baseURL: process.env.VUE_APP_API_LOGIN || '',
});

axiosPlugin.request = (config) => {
  // If the store is holding a "Token" we will sent the token to the API as part of a
  // Authorization HEADER.

  if (axiosPlugin.store.getters[ 'login/isLoggedIn' ]) {
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${axiosPlugin.store.getters[ 'login/isLoggedIn' ]}`;
    }
  }

  return config;
};

axiosPlugin.requestError = (error) => {
  return Promise.reject(error);
};

/**
 * SETTING UP SOME INTERCEPTORS FOR NUXT
 */
// Add a request interceptor
axios.interceptors.request.use(axiosPlugin.request, axiosPlugin.requestError);
// Add a response interceptor
axios.interceptors.response.use(axiosPlugin.response, axiosPlugin.responseError);


export default {
  install: (Vue, { store }) => {
    Vue.prototype.$axios = axios;
    Vue.axios = axios;
    store.$axios = axios;
    store.$localAxios = localAxios;
    axiosPlugin.store = store;
    axiosPlugin.Vue = Vue;
  },
};
